module.exports = __webpack_public_path__ + "static/img/loading-bird.234c132e.gif";